// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"197":"de8f7a56","949":"f155c9d1"}[chunkId] + ".chunk.js";
};